/**
 * url prefix of the current site and language, same result as customizeUrl() in php:
 * "/de/" for sites with is_unique_site = 1, "/<site code>/de/" otherwise (e.g. "/b2b/de/").
 * The React portal sets window.eilaShopUrlPrefix from its bootstrap (exact server value).
 */
export function shopLanguageCode() {
    const globals = window.GLOBALS || {};
    return String(globals.languageCode || window.languageCode || document.documentElement.lang || "de")
        .slice(0, 2)
        .toLowerCase();
}

export function shopUrlPrefix() {
    if (typeof window.eilaShopUrlPrefix === "string" && window.eilaShopUrlPrefix.startsWith("/")) {
        return window.eilaShopUrlPrefix;
    }
    const siteCode = (window.GLOBALS || {}).siteCode;
    const language = shopLanguageCode();
    const segments = window.location.pathname.split("/").filter(Boolean);
    if (siteCode && segments[0] === siteCode && segments[1] === language) {
        return `/${siteCode}/${language}/`;
    }
    return `/${language}/`;
}

/**
 * path segments after the site/language prefix ("/b2b/de/account/" -> ["account"])
 */
export function shopPathSegments(pathname = window.location.pathname) {
    const prefix = shopUrlPrefix();
    const path = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : pathname.split("/").filter(Boolean).slice(1).join("/");
    return path.split("/").filter(Boolean);
}

export function shopUrl(path = "") {
    return shopUrlPrefix() + String(path).replace(/^\/+/, "");
}
